"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useConfigurationContext = exports.ConfigurationProvider = exports.ConfigurationContext = void 0;
const react_1 = __importStar(require("react"));
const base_1 = require("@medely/base");
/**
 * This context provider makes it possible to access configuration values in hooks in our component
 * library, and to enforce a more consistent configuration object across our client apps
 */
/**
 *
 * @deprecated use ConfigurationContext from ui-kit instead
 */
const ConfigurationContext = (0, react_1.createContext)(base_1.defaultConfig);
exports.ConfigurationContext = ConfigurationContext;
/**
 *
 * @deprecated use ConfigurationProvider from ui-kit instead
 */
const ConfigurationProvider = ({ children, configuration }) => (react_1.default.createElement(ConfigurationContext.Provider, { value: Object.assign(base_1.defaultConfig, configuration) }, children));
exports.ConfigurationProvider = ConfigurationProvider;
/**
 *
 * @deprecated use useConfigurationContext from ui-kit instead
 */
const useConfigurationContext = () => (0, react_1.useContext)(ConfigurationContext);
exports.useConfigurationContext = useConfigurationContext;
